module.exports = __webpack_public_path__ + "img/cloudy.850d8de2.png";